import React, {} from 'react';
import FileUpload from "../../common/FileUpload";

export default function PhotoCategory(props) {
  return (
    <div className="cell small-12 medium-6 large-3">
      <FileUpload files={props.files} updateFileList={props.setFiles}>
        <p>{props.label}</p>
      </FileUpload>
    </div>)
}
